'use strict';

/**
 * 转换Number类型,并返回
 *
 * @author loganylwu
 * @param value
 * @param strict 若为严格模式，则未能成功转换的数据返回undefined
 */
export function checkToNumber(value: any, strict = true): number | undefined {
  let res;
  try {
    const numberValue = Number(value);
    if (!isNaN(numberValue)) res = numberValue;
  } catch (e) {}
  return res;
}
